<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .ask-ai {
    padding: 0 utils.in_rem(32px) 0 0;

    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: utils.in_rem(8px);
    position: relative;
  }
</style>

<script>
  import { getContext } from "svelte";
  import AnswerAI from "../../../../components/elements/AnswerAI.svelte";
  import { activityFeedStore } from "../../stores";
  import Inputs from "./Inputs.svelte";
  import { CONTACT_AI_CONTEXT } from "./context";

  const {
    promptStore,
    chatStore,
    contactChatAskApiStore,
    contactChatThinkingStore,
    thinking,
  } = getContext(CONTACT_AI_CONTEXT);

  const { meta } = activityFeedStore;
  $: showSkeleton = $meta.fetching || !$meta.firstFetchDone;
</script>

<div class="ask-ai">
  <AnswerAI
    apiStore={contactChatAskApiStore}
    {promptStore}
    {chatStore}
    thinkingStore={contactChatThinkingStore}
    {thinking}
    {showSkeleton}
  />
  {#if !showSkeleton}
    <Inputs />
  {/if}
</div>
